export default __webpack_public_path__ + "static/1388-fd1537183a1918e4998b32bae40a7c16.gif";